export const myTaxTranslationsEn = {
  MY_TAX_FAMILY_TAX_APPLICATION_INFO: "If you use the family discount alone as indicated in point 2, the spouse/partner's details will not be filled in accordingly when saving or printing the declaration. Are you sure you want to continue?",
  MY_TAX_DECLARATION_REMOVED_FAILED: "The tax application remove failed.",
  MY_TAX_DECLARATION_REMOVED_SUCCESSFULLY: "Tax declaration removed successfully",
  MY_TAX_MODIFIED_DECLARATION: "modified declaration",
  MY_TAX_PREVIOUS_TAX_DECLARATION_DELETED: "The previous tax declaration has been deleted",
  MY_TAX_APPLICATION_SAVE_FAILED: "The tax application save failed.",
  MY_TAX_INVALID: "Invalid",
  MY_TAX_MODIFIED_APPLICATION: "Modified application",
  MY_TAX_MODIFIER_APPLICATION: "Modifier application",
  MY_TAX_DECLARATION_CREATED_FAILED: "The tax declaration could not be saved",
  MY_TAX_DECLARATION_CREATED_SUCCESSFULLY: "The tax declaration saved",
  MY_TAX_TAXDECLARATIONFAMILY: "Adóelőleg-nyilatkozat a családi kedvezmény és járulékkedvezmény érvényesítéséről",
  MY_TAX_TAXDECARATIONMOTHERUNDER30: "Adóelőleg-nyilatkozat a 30 év alatti anyák kedvezményének érvényesítéséről",
  MY_TAX_TAXDECLARATIONFIRSTMARRIEDPERSON: "Adóelőleg-nyilatkozat az első házasok kedvezményének érvényesítéséről",
  MY_TAX_TAXDECLARATIONUNDER25: "Nyilatkozat a 25 év alatti fiatalok kedvezményének részben vagy egészben történő érvényesítésének mellőzéséről",
  MY_TAX_TAXDECLARATIONELIGIBLECOSTS: "Adóelőleg-nyilatkozat az adóelőleg meghatározásakor figyelembe vehető költségekről",
  MY_TAX_TAXDECLARATIONPERSONAL: "Adóelőleg-nyilatkozat a személyi kedvezmény érvényesítéséről",
  MY_TAX_TAXDECLARATIONFOURCHILDREN: "Adóelőleg-nyilatkozat a négy vagy több gyermek után járó adókedvezmény érvényesítéséről",
  MY_TAX_STATE_K: "Submitted",
  MY_TAX_STATE_E: "Approved",
  MY_TAX_STATE_T: "Invalid",
  MY_TAX_STATE_V: "Rejected",
  MY_TAX_SUBMITTED_APPLICATIONS: "Submitted applications",
  MY_TAX_CREDIT_REQUEST_CREATED_AT: "Requests created at",
  MY_TAX_AVAILABLE_APPLICATIONS: "Avaiable applications",
  MY_TAX_MY_APPLICATIONS: "My applications",
  MY_TAX_TAX_CREDIT_APPLICATIONS_SETTING_INFO: "The content of the tax credit application is saved in the JDolBer HR system.",
  MY_TAX_CREDIT_APPLICATIONS: "Tax credit applications",
  MY_TAX_APPLICATIONS_MENU_INFO: "Displaying tax returns",
  MY_TAX_TO_APPLICATIONS: "Continue to applications",
  MY_TAX_PLEASE_SELECT: "Please select",
  MY_TAX_TAX_CREDIT_MONTH: "Month",
  MY_TAX_TAXDECLARATIONTHREECHILDREN: "Adóelőleg-nyilatkozat a két, a három, illetve a négy vagy több gyermeket nevelő anyák kedvezményének érvényesítéséről",
  MY_TAX_TAXDECLARATIONCOMBINED: "Összevont adóelőleg-nyilatkozat a családi kedvezmény és a két, a három, illetve a négy vagy több gyermeket nevelő anyák kedvezményének érvényesítéséről"
};
